import { render } from "./PaymentRecords.vue?vue&type=template&id=5de9aef6&scoped=true"
import script from "./PaymentRecords.vue?vue&type=script&lang=js"
export * from "./PaymentRecords.vue?vue&type=script&lang=js"

import "./PaymentRecords.vue?vue&type=style&index=0&id=5de9aef6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de9aef6"]])

export default __exports__